module.exports = __webpack_public_path__ + "assets/img/81a8efc2525ee064214326f39e4a78e7.png";